// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hadC","toggle":"styles_toggle__Vun33","preview":"styles_preview__ZH4Tt"};